import {Component, OnDestroy, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LangService, NavigateService, ShortcutAction, FormService} from 'ngx-satoris';
import {ApiService} from '../../../shared/services/api.service';
import {CartService} from '../../../shared/services/cart.service';
import {RequestService} from '../../../shared/services/request.service';
import {InactivityService} from '../../../shared/services/inactivity.service';
import {Direction} from '../../../shared/models/forms';
import {ScanDocumentService} from 'src/app/shared/services/scan-document.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-9.reason-request',
  templateUrl: './reason-request.component.html',
  styleUrl: './reason-request.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ReasonRequestComponent implements OnDestroy {

  selected: string;
  keepScanned = false;
  paramDirection: Direction;
  config = this.cart.currentRequest?.formConfig || undefined;
  reasonForm: FormGroup;
  reasonSubmitted = false;

  constructor(public api: ApiService,
    public cart: CartService,
    public request: RequestService,
    public nav: NavigateService,
    private inactivity: InactivityService,
    private route: ActivatedRoute,
    private scanDoc : ScanDocumentService,
    private lang: LangService,
    private fb: FormBuilder,
    public forms: FormService) {
    this.route.queryParams.subscribe(params => {
      if(params && params.direction) this.paramDirection = params.direction;
      if(params && params.visaType) this.selected = params.visaType;

    });
    if(!this.inactivity.isWatching && this.api.userRole.isKiosk) this.inactivity.startWatching();
  }

  requestReasonOptions: { value: string, name: string }[] = [];

  ngOnInit() {
    const schemaId = this.cart.currentRequest?.visaType?.schema || this.cart.currentRequest?.visaType?.id;
    if(schemaId) {
      this.config = this.api.schemaSync(schemaId);
      if(this.config) {
        this.requestReasonOptions = this.extractRequestReasonOptions(this.config);
      }
    }
    this.reasonForm = this.fb.group({
      REQUEST_REASON: ['', Validators.required]
    });
  }

  /**
   * Extract all the options enum for REQUEST_REASON in all the if/then/else/allOf of the schema
   */
  private extractRequestReasonOptions(schema: any): { value: string, name: string }[] {
    const found: Set<string> = new Set();
    const options: { value: string, name: string }[] = [];
    const lang = this.lang;

    function search(obj: any) {
      if(!obj || typeof obj !== 'object') return;

      if(
        obj.properties &&
        obj.properties.Documents &&
        obj.properties.Documents.properties &&
        obj.properties.Documents.properties.RequestReason &&
        Array.isArray(obj.properties.Documents.properties.RequestReason.enum)
      ) {
        for(const val of obj.properties.Documents.properties.RequestReason.enum) {
          if(!found.has(val)) {
            found.add(val);
            options.push({value: val, name: lang.transform('DYN.' + val) || val});
          }
        }
      }

      if(obj.properties && obj.properties.REQUEST_REASON && Array.isArray(obj.properties.REQUEST_REASON.enum)) {
        for(const val of obj.properties.REQUEST_REASON.enum) {
          if(!found.has(val)) {
            found.add(val);
            options.push({value: val, name: lang.transform('DYN.' + val) || val});
          }
        }
      }

      for(const key of ['allOf', 'anyOf', 'oneOf']) {
        if(Array.isArray(obj[key])) {
          for(const sub of obj[key]) search(sub);
        }
      }

      for(const key of ['if', 'then', 'else']) {
        if(obj[key]) search(obj[key]);
      }
    }

    search(schema);
    return options;
  }

  ngOnDestroy() {
    if(!this.keepScanned) {
      this.scanDoc.scanned = false;
    }
  }

  getReasonError() {
    if(!this.reasonSubmitted) return null;
    const errors = this.forms.getFormErrors(this.reasonForm, 'REQUEST_REASON');
    return errors.length ? errors[0].keyError : null;
  }

  next() {
    this.reasonSubmitted = true;
    if(this.reasonForm.invalid) {
      return;
    }
    // Store reason in indexed for printing and in currentRequest for later use in the form
    if(this.cart.currentRequest) {
      this.cart.currentRequest.selectedRequestReason = this.reasonForm.value.REQUEST_REASON;
      this.cart.saveCurrentApplication(false);
    }
    this.nav.to('form-visa');
  }

  previous() {
    if(this.scanDoc?.scanned) {
      this.keepScanned = true;
    }
    if(this.api.env.formReasonRequestStep) {
      this.nav.to('visa-type', undefined, {queryParams: {direction: Direction.PREVIOUS}});
    } else if(this.api.env.hasMultiPersonView) {
      this.nav.to('participants', undefined, {queryParams: {direction: Direction.PREVIOUS}});
    } else {
      this.nav.to('dashboard');
    }
  }

  protected readonly ShortcutAction = ShortcutAction;
}
